import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  The levy only applies to land within the MSA Levy Area Boundary. If you wish to determine offset obligations for the portion covered by the Native Vegetation Regulations Area, please proceed to the{' '}  <InlineLink href="https://mapshare.vic.gov.au/nvr/" text="Native Vegetation Removal Regulations" mdxType="InlineLink" /> tool.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      